<template>
  <div class="webfooter">
    <div class="webfooter_main">
      <div class="friend_url left">
        <span class="title">友情链接：</span>
        <a title="心密之家" target="_blank" href="https://www.xinmizj.com/ ">心密之家</a>
        <!--<a title="经典学辞典" target="_blank" href="">经典学辞典</a>-->
      </div>
      <!--备案这句  只在旧域名加-->
      <!--<p class="titlep">主办单位：佛心寺
      湘ICP备2023005744号
      互联网宗教信息服务许可证：湘（2022)0000026</p>-->
      <!--jxxfjxh域名 备案-->
      <p class="titlep">Copyright©2023 金山县佛教协会, 鲁ICP备2023008974号-1《互联网宗教信息服务许可证》编号：鲁（2023）0000005</p>
      <!--<div class="webinfo left textover">-->
        <!--&lt;!&ndash;<span class=" about">Copyright © 2020 WWW.HLJSYXJS.COM ALL RIGHTS RESERVED　黑ICP备2021006333 </span>&ndash;&gt;-->
        <!--&lt;!&ndash;<a class="url"  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=23010302001101" target="_blank">&ndash;&gt;-->
          <!--&lt;!&ndash;<img src="../../assets/images/ba.png" alt="黑公网安备23010302001101号" title="黑公网安备23010302001101号">&ndash;&gt;-->
          <!--&lt;!&ndash;<span class="searchtxt">黑公网安备23010302001101号</span>&ndash;&gt;-->
        <!--&lt;!&ndash;</a>&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="clear clearfix"></div>&ndash;&gt;-->
      <!--</div>-->
      <div class="clear clearfix"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "web_footer",
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  .webfooter{
    width:100%;
    height:7rem;
    background: #c9a168;
    position: fixed;
    bottom:0;
    left:0;
    z-index:10;
    .webfooter_main{
      width:95rem;
      min-width:1300px;
      margin:0 auto;
      height:100%;
      /*padding-left:9rem;*/
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .friend_url{
        /*height:100%;*/
        /*line-height: 7rem;*/
        font-size:0.9rem;
        padding-right:2rem;
        /*width:20%;*/
        span{
          letter-spacing: .3rem;
          font-size:0.9rem;
          color:#fff;
          line-height: 1.6;
        }
        a{
          font-size:0.9rem;
          letter-spacing: .3rem;
          color:#fff;
          margin-right:2rem;
        }
        a:last-child{
          margin-right:0;
        }
      }
      .webinfo{
        height:100%;
        line-height: 7rem;
        font-size:0.9rem;
        color:#fff;
        text-align: center;
        /*width:78%;*/
        display: flex;
        justify-content: center;
        .url{
          display: flex;
          align-items: center;
          margin-left:2.6rem;
        }

        .about{
          letter-spacing: 1px;
        }
        .left{
          /*margin-left:2.6rem;*/
        }
        .imgs{
          line-height: 7rem;
        }
        img{
          width:1.3rem;
        }
        span{
          height:100%;
          line-height: 7rem;
          font-size:0.9rem;
          color:#fff;
          text-align: left;
          letter-spacing: 1px;
        }
        .searchtxt{
          padding-left:0.9rem;
        }
      }
    }
  }
  /*备案这句  只在旧域名加*/
  .titlep{
      margin:0;
      letter-spacing: .2rem;
      font-size:0.9rem;
      color:#fff;
      line-height: 1.6;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/web_footer.vue